import type { Confirmation } from "../types/confirmations.types";

export const MOCK_PENDING: Confirmation[] = [];
export const MOCK_CONFIRMED: Confirmation[] = [];
